const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const parseTime = (timestr) => {
  let t = timestr.split(":");
  if (!t[0] || !t[1]) return false;
  t[0] = t[0].trim();
  t[1] = t[1].trim()

  let hours = Number(t[0]);
  let minutes = Number(t[1].substr(0, 2));
  let AmPm = t[1].substr(2);
  if (isNaN(hours) || isNaN(minutes) || (AmPm !== 'AM' && AmPm !== 'PM')) return false;

  if (AmPm === 'PM') hours = hours + 12;
  return {
    hours,
    minutes
  }
}

export const parseDateTime = (str) => {
  if (!str) return false
  let date = str.split(',')[0];
  if (!date) return false
  date = date.split(' ');
  if (date.length !== 3) return false
  let month = months.indexOf(date[0]);
  let day = Number(date[1]);
  let year = Number(date[2]);

  if (month < 0 || isNaN(day) || isNaN(year) || date[2].length !== 4) return false
  let time = str.split(',')[1];
  if (!time) return false
  time = time.trim().split("-");
  let startTime = time[0];
  let endTime = time[1];
  if (!startTime || !endTime) return false
  startTime = parseTime(startTime);
  endTime = parseTime(endTime);
  if (!startTime || !endTime) return false
  let startDateTime = new Date(year, month, day, startTime.hours, startTime.minutes);
  let endDateTime = new Date(year, month, day, endTime.hours, endTime.minutes);
  if (startDateTime.getTime() > endDateTime.getTime()) return false
  let res = {
    startAt: startDateTime.toISOString(),
    endAt: endDateTime.toISOString()
  }
  return res
}

export const formatTime = (date) => {
  let h = date.getHours();
  let m = date.getMinutes();
  let amPm = "AM";
  if (h > 12) {
    h = h - 12;
    amPm = "PM";
  }
  if (h == 12) {
    amPm = "PM";
  }
  if (h == 0) {
    h = 12;
  }
  if (m < 10) m = "0" + m
  return h + ":" + m + amPm
}

export const parseDate = (d) => {
  const date = new Date(d);
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return month + "/" + day + "/" + date.getFullYear() + ", " + formatTime(date);
}

export const parseDateTimeToString = (startAt, endAt) => {
  const start = new Date(startAt);
  const end = new Date(endAt);
  const month = months[start.getMonth()];
  const date = start.getDate();
  const year = start.getFullYear();
  const startTime = formatTime(start);
  const endTime = formatTime(end);
  let datStr = month + " " + date + " " + year + ", " + startTime + " - " + endTime
  return { dateTime: datStr }
}

export const parseDateToString = (startAt) => {
  const start = new Date(startAt);
  const month = months[start.getMonth()];
  const date = start.getDate();
  const year = start.getFullYear();
  const startTime = formatTime(start);
  return date + " " + month + " " + year + ", " + startTime
}
